<div id="confirm-registration" class="confirm-registration" tabindex="-1" autofocus>
  <div class="backgroundImage" tabindex="-1"></div>
  <div class="backgroundImage2" tabindex="-1"></div>
    <div class="mainHeading" tabindex="-1">
      <div class="content" tabindex="-1">
        <img
          class="logo"
          src="assets/MyToyota_Primary.svg"
          [alt]="state.logo.altText"
          tabindex="0"
        />
        <h1 tabindex="0">{{ state.pageHeading }}</h1>
        <p tabindex="0" class="adminPending" [innerHTML]="state.pageDescription">
          {{ state.pageDescription }}
        </p>
        <div class="confirm-registration--refreshButton">
          <kng-button
            (click)="refreshPage()"
            [state]="state.refreshPageButton"
          ></kng-button>
        </div>
      </div>
    </div>
    <kng-footer tabindex="0" [state]="state.footer"></kng-footer>
</div>

<div class="overlay" *ngIf="state.loading">
  <kng-loader [state]="loaderState"></kng-loader>
</div>